module.exports = __webpack_public_path__ + "img/590-42dfb3.png";